// 平台、用户中心
export const UserCenterRoutes = [
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () =>
      import(
        '@/views/UserSection/UserCenter' /* webpackChunkName: "jincheng-yibao-user-center" */
      ),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/register-protocol',
    name: 'RegisterProtocol',
    component: () =>
      import(
        '@/views/UserSection/RegisterProtocol' /* webpackChunkName: "jincheng-yibao-register-protocol" */
      ),
    meta: {
      title: '注册协议'
    }
  },
  {
    path: '/privacy-statement',
    name: 'PrivacyStatement',
    component: () =>
      import(
        '@/views/UserSection/PrivacyStatement' /* webpackChunkName: "jincheng-yibao-privacy-statement" */
      ),
    meta: {
      title: '隐私声明'
    }
  },
  {
    path: '/company-appointment',
    name: 'CompanyAppointment',
    component: () =>
      import(
        '@/views/CompanyAppointment/CompanyAppointment' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '企业参保信息收集',
      notForce: true
    }
  },
  {
    path: '/guarantee',
    name: 'Guarantee',
    component: () =>
      import(
        '@/views/NoticePage/guarantee' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '保障计划表',
      notForce: true
    }
  },
  {
    path: '/claimNotice',
    name: 'ClaimNotice',
    component: () =>
      import(
        '@/views/NoticePage/claimNotice' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '理赔须知',
      notForce: true
    }
  },
  {
    path: '/claimNotice_2021',
    name: 'ClaimNotice_2021',
    component: () =>
      import(
        '@/views/NoticePage/claimNotice_2021' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '理赔须知',
      notForce: true
    }
  },
  {
    path: '/healthManual',
    name: 'HealthManual',
    component: () =>
      import(
        '@/views/NoticePage/healthManual' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '健康管理服务手册',
      notForce: true
    }
  },
  {
    path: '/healthManual_2021',
    name: 'HealthManual_2021',
    component: () =>
      import(
        '@/views/NoticePage/healthManual_2021' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '健康管理服务手册',
      notForce: true
    }
  },
  {
    path: '/productSpecification',
    name: 'ProductSpecification',
    component: () =>
      import(
        '@/views/NoticePage/productSpecification' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '产品说明书',
      notForce: true
    }
  },
  {
    path: '/productSpecification_2021',
    name: 'ProductSpecification_2021',
    component: () =>
      import(
        '@/views/NoticePage/productSpecification_2021' /* webpackChunkName: "jincheng-yibao-company-appointment" */
      ),
    meta: {
      title: '产品说明书',
      notForce: true
    }
  }
]
